import * as React from 'react';

import { WellbeingScore } from 'src/modules/assessments/components/WellbeingScore';

export const WellbeingScoreStep: React.FC = props => {
    return <WellbeingScore {...props} hideReturnButton />;
};

export default WellbeingScoreStep;
